import $ from 'jquery';
import { addMessage } from './messages';

export const showError = (errorMessages) => addMessage(errorMessages, 'danger');

export const clearErrorMessages = () => {
    var el = $('#messages-bag .alert-danger:not(.fixed-message)').slideUp({
        complete: () => el.remove(),
    });
};

export const processErrorResponse = (
    error,
    defaultMessage = 'Ocorreu um erro desconhecido nessa operação, favor tentar novamente mais tarde',
) =>
    new Promise((fullfill) => {
        if (error.statusText == 'abort') {
            return;
        }

        var json = error.responseJSON;
        if (typeof json === 'undefined' || typeof json.error === 'undefined') {
            console.error(error);
            return fullfill({
                status: 400,
                error: defaultMessage,
            });
        }

        fullfill({
            status: json.status || 400,
            error: json.error || defaultMessage,
            reload: json.redirectToLogin || false,
            flashType: json.flashType || "default",
        });
    });

export const showErrorFromResponse = (error) =>
    processErrorResponse(error).then(({ error, reload }) => {
        reload && window.location.reload();
        showError(error);
    });

export const showErrorDialogFromResponse = (error) =>
    processErrorResponse(error).then(({ error, reload, flashType }) => {
        if (flashType === 'warning') {
            showWarningDialog(error, reload);

            return;
        }

        showErrorDialog(error, reload);
    });

const showDialog = (modalId, error, reload) => {
    const modal = $(modalId);
    const otherModals = $(`.modal:not(${modalId})`);
    modal.off('hidden.bs.modal').on('hidden.bs.modal', () => {
        otherModals.removeClass('ofuscated');

        if (reload) {
            window.location.reload();
        }
    });

    modal.find('.modal-body').html(error);

    otherModals.addClass('ofuscated');
    modal.modal('show');
};

export const showErrorDialog = (error, reload = false) =>
    showDialog('#alertModalError', error, reload);

export const showWarningDialog = (error, reload = false) =>
    showDialog('#alertModalWarning', error, reload);
